"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Breadcrumb_1 = __importDefault(require("./Breadcrumb"));
var accessors_1 = require("../themes/accessors");
var StyledBreadcrumbs = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n  padding: 0;\n\n  & > * + * {\n    margin-left: ", "px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n  padding: 0;\n\n  & > * + * {\n    margin-left: ", "px;\n  }\n"])), accessors_1.space('sm'));
var labelContent = function (label, isLast) {
    return label + (isLast ? '' : ' /');
};
var Breadcrumbs = function (_a) {
    var breadcrumbs = _a.breadcrumbs, otherProps = __rest(_a, ["breadcrumbs"]);
    return react_1.default.createElement(StyledBreadcrumbs, __assign({}, otherProps), breadcrumbs.map(function (breadcrumb, index) {
        var label = labelContent(breadcrumb.label, (index + 1 === breadcrumbs.length));
        var onItemSelect = breadcrumb.onSelect;
        return react_1.default.createElement(Breadcrumb_1.default, { key: label, label: label, isSelected: breadcrumb.isSelected, onClick: onItemSelect
                ? function (event) { return onItemSelect(breadcrumb, event); }
                : undefined });
    }));
};
exports.Breadcrumbs = Breadcrumbs;
exports.default = exports.Breadcrumbs;
var templateObject_1;
